module.exports = __webpack_public_path__ + "assets/img/28_978.5b6daa89.jpg";